import { InputBase } from '@mui/material';
import { styled } from '@mui/material/styles';

import { colors } from 'styles/globalStyles';

export const StyledInput = styled(InputBase)(() => ({
  '&': {
    width: '100%',
  },
  '& .MuiInputBase-input': {
    borderRadius: '4px',
    position: 'relative',
    border: '1px solid',
    borderColor: colors.borderGrey,
    padding: '6px 8px',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '17px',
    '&:focus': {
      borderColor: colors.focusBlue,
    },
    '::placeholder': {
      opacity: 0.42,
    },
  },

  '&.Mui-error input': {
    borderColor: colors.red,
  },
}));

export const InputFieldContainer = styled('div')({
  width: '100%',
});
